// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'forward-all-solid';

export const Component = () => (
  <path d='M24.078 12.731 16.67 19.47a.428.428 0 0 1-.328.139c-.328 0-.469-.184-.469-.507 0-.139.047-.23.141-.323l7.407-6.739c.094-.046.14-.138.14-.277 0-.046-.046-.184-.14-.369l-7.407-7.061a.415.415 0 0 1-.14-.323c0-.323.14-.507.468-.507.047 0 .14.045.328.138l7.407 7.108c.281.23.422.554.422 1.016 0 .369-.14.692-.422.969v-.002Zm-2.719-1.661-7.547-7.431a.535.535 0 0 0-.375-.139c-.328 0-.468.184-.468.507v4.247C5.14 8.254.968 12.5.5 20.993c0 .323.14.507.469.507a.496.496 0 0 0 .422-.23c1.64-2.447 3.375-4.154 5.203-5.077 1.829-.877 3.938-1.339 6.376-1.339v4.247c0 .323.14.507.468.507.047 0 .188-.046.375-.139l7.547-7.06c.188-.231.282-.462.282-.647 0-.23-.094-.461-.282-.692Z' />
);

export const viewBox = '0 0 25 25';
